export default __webpack_public_path__ + "static/media/FB.ec7214b7.jpg";